module.exports = __webpack_public_path__ + "static/media/Woodland-Pines-Bylaws.1cc2b372.pdf";